export default "__VITE_ASSET__49aea190__"